<!--
- 自动授权页面, 接受三方(如: App) 跳转到此页面
- 通过 `code` 获取 `token` 后, 重定向到 `redirect` 指定的页面上
-->

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router/composables'
import { api } from '@/api'
import { ERROR_PAGE_LEVEL } from '@/constants'
import { $login } from '@/helpers'

const props = defineProps<{
  redirect?: string
  appId?: string
  code?: string
  state?: string
}>()

const router = useRouter()
const failed = ref('')

onMounted(async () => {
  if (!props.code) {
    failed.value = '缺少 code 参数'
    return
  }

  try {
    const { data } = await api.get<any, GetKuaishouMemberAuthLoginResponse>('/kuaishou/member/auth/login', {
      params: {
        appId: props.appId,
        code: props.code,
      },
    })
    const { token, openId } = data
    $login({ token, openId })
    router.replace({ path: props.redirect ?? '/' })
  }
  catch (error: any) {
    console.error(error)
    failed.value = error.msg || '服务器错误'
    router.replace({
      name: 'error',
      query: {
        level: ERROR_PAGE_LEVEL.FATAL,
        message: '很抱歉，授权失败',
        redirect: window.encodeURIComponent(window.location.href),
      },
    })
  }
})
</script>

<template>
  <div class="w-full h-screen bg-white">
    <div class="mt-20vh flex justify-center">
      <BasicSpinner v-if="!failed" class="mx-auto" />
    </div>
    <p class="mt-8 font-bold text-center">
      <span>{{ failed || '授权中' }}</span>
    </p>
    <div class="mt-40 flex justify-center" />
  </div>
</template>
